
import { useState } from 'react';
import { trpc } from '@/utils/api-client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient, trpcClientConfig } from '@/utils/api-client';

interface TrpcProviderProps {
  children: React.ReactNode;
}

export default function TrpcProvider({ children }: TrpcProviderProps) {
  const [trpcClient] = useState(() => trpc.createClient(trpcClientConfig as any));

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
}
